import { EventHub } from "@/constants/constants"
import { gpsService } from '@/services/gps.service'
import { lineService } from '@/services/line.service'
import { DialogLINE } from "@/tools/dialog"
import i18n from '@/i18n'
import { mapActions } from 'vuex'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'GpsDialogFirstTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // selector de marcas
        brands: [],
        // selector de modelos
        models: [],
        // líneas
        lines: [],
        // estados
        states: [],
        // mensajes de error para el unitId
        unitIdError: [],
        // loading
        loadingLines: false,
        loadingBrands: false,
        loadingModels: false,
        loadingStates: false,
        // model para el formulario
        isValidForm: false,
        // para validación de unitId
        actualUnitId: null,
        // número que identifica la línea que se está creando para luego 
        newLineCreated: null,
    }),
    computed: {
    },
    created () {
        // Evento lanzado por el diálogo de creación de línea, cuando se guarda la nueva línea
        this.$eventBus.$on(EventHub.COMMIT_LINE, (lineDto) => {
            this.getLines(lineDto._id)
        })
        this.actualUnitId = this.model.unitId
        this.getLines()
        this.getBrands()
        this.getStates()
        if (this.model.update) {
            this.initSelectorsData()
        }
    },
    beforeDestroy() {
        // desuscripción al bus de eventos
        this.$eventBus.$off(EventHub.COMMIT_LINE)
    },
    mounted () {
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        /**
         * Líneas no asignadas
         * @param lineId id de la línea insertada
         */
        getLines (lineId) {
            this.loadingLines =  true
            lineService.findAllNonAssigned().then(response => {
                this.lines.push(...response)
                if (lineId) {
                    if (this.newLineCreated === 1) {
                        this.model.line1 = lineId
                    } else if (this.newLineCreated === 2) {
                        this.model.line2 = lineId
                    }
                }
                this.newLineCreated = null
                this.loadingLines = false
            })
        },
        /**
         * Marcas
         */
        getBrands() {
            this.loadingBrands = true
            gpsService.getBrands().then(response => {
                this.brands = response
                this.loadingBrands = false
            })
        },
        /**
         * Modelos según marca
         * @param {*} brandId
         */
        getModels(brandId) {
            if (brandId) {
                this.loadingModels = true
                gpsService.getModels(brandId).then(response => {
                    this.models = response
                    this.loadingModels = false
                })
            } else {
                this.models = []
            }
        },
        /**
         * Estados
         */
        getStates() {
            this.loadingStates = true
            gpsService.getStates().then(response => {
                this.states = response
                this.loadingStates = false
            })
        },
        /**
         * Carga el dialog para crear líneas
         * @param line número que identifica a la línea creada (1 o 2), se configura en el template
         */
        openLine(line) {
            this.newLineCreated = line
            const bread = {
                key: DialogLINE,
                disabled: true,
                text: this.$t('line.name')
            }
            this.pushBread(bread)
        },
        /**
         * Método para validar el unitId luego del evento blur
         */
        identificatorDuplicateMethod() {
            if (this.actualUnitId === this.model.unitId) return
            gpsService.validateUnitId(this.model.unitId).then(response => {
                if (response) {
                    this.unitIdError.push(`${i18n.t('gps.duplicate')}`)
                } else {
                    this.unitIdError = []
                }
            })
        },
        /**
         * Para inicializar los selectores de línea en la actualización
         */
        initSelectorsData() {
            this.loadingLines = true
            if (this.model.line1) {
                this.lines.push({ _id: this.model.line1, lineNumber: this.model.line1Number })
            }
            if (this.model.line2) {
                this.lines.push({ _id: this.model.line2, lineNumber: this.model.line2Number })
            }
            this.loadingLines = false
            if (this.model.brandId && this.model.modelId) {
                this.loadingModels = true
                gpsService.getModels(this.model.brandId).then(response => {
                    this.models = response
                })
                this.loadingModels = false
            }
        },
        /**
         * Cada vez que se modifica la selección del estado, se cargan
         */
        stateSelectedFunction (newValue) {
            this.model.stateId = newValue.id ? newValue.id : newValue;
        },
        /**
         * Cada vez que se modifica la selección de la marca, se cargan
         */
        brandSelectedFunction (newValue) {
            this.model.brandId = newValue.id ? newValue.id : newValue;
            this.getModels(this.model.brandId);
        },
        /**
         * Cada vez que se modifica la selección del modelo, se cargan
         */
        modelSelectedFunction (newValue) {
            this.model.modelId = newValue.id ? newValue.id : newValue;
        },
        /**
         * Cada vez que se modifica la selección de la linea, se cargan
         */
        lineSelectedFunction (newValue, line) {
            if (line === 1) {
                this.model.line1 = newValue._id ? newValue._id : newValue;
            } else {
                this.model.line2 = newValue._id ? newValue._id : newValue;
            }
        },
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.gpsDialogFirstTabForm) {
                this.$refs.gpsDialogFirstTabForm.resetValidation()
            }
        }
    }
}
